import { Checkbox } from '@components/old-rolex-ui'
import { cn } from '@lib/cn'
import { FC } from 'react'
import { useInView } from 'react-intersection-observer'
import { RCPOFilter } from '../hooks/use-rcpo-data'
import { useSetFilterParameter } from '../hooks/use-set-filter-parameter'

type FilterGroupProps = RCPOFilter & {
  attributeValuePrefix?: string
}

export const FilterGroup: FC<FilterGroupProps> = ({
  attributeID,
  articleFilterAttributeValues,
  attributeValuePrefix,
}) => {
  const { setFilterParam, activeFilters } = useSetFilterParameter(attributeID)
  const [lastElRef, lastElInView] = useInView()

  return (
    <div className="relative mb-12 ">
      <div className="flex h-auto max-h-[300px] flex-col items-start overflow-auto">
        {articleFilterAttributeValues &&
          articleFilterAttributeValues.map((value, index) => {
            const isActive = activeFilters.includes(value.attributeValueID.toString())

            return (
              <Checkbox
                key={index}
                disabled={!value.isAvailable}
                checked={isActive}
                className={'text-shade-800 disabled:text-rolexShade-300'}
                onClick={() => setFilterParam(value.attributeValueID)}
                label={
                  attributeValuePrefix
                    ? `${attributeValuePrefix} ${value.attributeValue}`
                    : value.attributeValue
                }
              />
            )
          })}
        <div ref={lastElRef} className="block w-full py-2" />
        <span
          className={cn(
            'absolute bottom-0 left-0 block h-8 w-full bg-gradient-to-t from-white/80 to-transparent',
            lastElInView && 'opacity-0',
          )}
        />
      </div>
    </div>
  )
}
